<template>
  <step-container
    title="¿Algún pedido especial o algo que debamos saber?"
    class="scroll-m-40"
    :number="stepNumber"
  >
    <div class="w-full">
      <div class="mx-auto md:px-4 flex flex-col gap-2">
        <label for="additional-info" class="inline-flex text-sm font-medium leading-6">
          Escribe aquí lo que necesites para ayudarte a crear una experiencia perfecta y a
          la medida:
        </label>
        <textarea
          placeholder="Ej: urgencia de fecha; necesidad especial del entrevistad@; sorpresa que le quieran hacer al entrevistad@; etc."
          class="w-full h-full rounded-md border-0 py-3 px-4 text-neutral-800 ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-pink-600 focus-visible:outline-none sm:text-sm sm:leading-6"
          type="text"
          name="additional-info"
          rows="4"
          v-model="additionalInfo"
        />

        <div class="text-center mt-8 min-h-11">
          <styled-button
            v-if="!completed"
            title="Continuar"
            :disabled="isLoading"
            @click="handleContinue"
          />
        </div>
      </div>
    </div>
  </step-container>
</template>

<script>
import stepMixin from "../../mixins/step";
import StyledButton from "../layouts/StyledButton.vue";
import { createQuotation } from "../../../../../api/quotation";

export default {
  mixins: [stepMixin],
  inject: ["isAuthenticated"],
  components: { StyledButton },
  props: {
    value: {
      type: Object,
      required: true,
    },
    handleAdditionalInfoCompleted: {
      required: true,
    },
  },
  methods: {
    handleContinue() {
      if (this.isAuthenticated) {
        this.submitQuotation();
      } else {
        this.completed = true;
        this.handleAdditionalInfoCompleted();
      }
    },
    async submitQuotation() {
      const quotationData = {
        motive: this.value.motive,
        interview_service_id: this.value.interviewServiceId,
        format: this.value.format,
        modality: this.value.modality,
        protagonist_first_name: this.value.protagonistFirstName,
        protagonist_last_name: this.value.protagonistLastName,
        protagonist_nickname: this.value.protagonistNickname ?? null,
        protagonist_interviewee: this.value.protagonistInterviewee,
        additional_info: this.value.additionalInfo,
      };

      this.isLoading = true;
      try {
        const response = await createQuotation({ quotation: quotationData });
        window.location.href = `/quotations/${response.data.token}/success`;
      } catch (error) {
        console.error(error);
      }
      this.isLoading = false;
    },
  },
  data() {
    return {
      additionalInfo: this.value.additionalInfo,
      completed: false,
      isLoading: false,
    };
  },
  watch: {
    additionalInfo(value) {
      this.$emit("input", { ...this.value, additionalInfo: value });
    },
  },
};
</script>
